<template>
  <v-container :class="this.bgclass=='darkbg'?'section-pricing lightbg':'section-pricing grey lighten-4 grey--text text--darken-3'" id="section-pricing">
    <v-container class="pb-0">
      <pricing-hears :user="this.user" :bgclass="this.bgclass"></pricing-hears>
    </v-container>
  </v-container>
</template>

<script>
import PricingHears from '@/components/pages/public/pricing/PricingHears.vue';

export default {
  name: "SecPricing",
  components: {
    PricingHears,
  },
  props: ['bgclass', 'showtitle', 'user'],
  data: () => ({
    activeTab: 1,
    tabs: {pm: 0, ph: 1, pr: 2},
  }),
  mounted(){
    if (this.$route.query.px != null){
      this.activeTab = this.tabs[this.$route.query.px];
    }
  },
};
</script>

<style scoped>
.v-card__subtitle {
  min-height: 100px;
}
.card-pricing {
  border-top: solid;
  border-top-width: thick;
  border-color: primary;
}
.plan-price {
  font-size: xxx-large;
}
.starting-from {
  position: absolute;
  left: 45px;
  font-size: 12px;
  line-height: 14px;
  font-family: 'ProximaNova-Regular';
  text-align: right;
}
.col-flex-basis-1 {
  flex-basis: auto;
}
dl.prefered > dd {
  font-weight: 800;
}
</style>
